import React from "react";
import { Translation, t } from "../../../core/translate";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import {
  selectors as userSelectors,
  actions as userActions
} from "../../../../redux/user";
import {
  actions as routerActions,
  selectors as routerSelectors
} from "../../../../redux/router";
import Spinner from "../../../components/spinner";
import ContainerLayout from "../container-layout";
import { Button, Form, TextField } from "@vitalsource/vstui";
import Password from "../registration/password";
import SecurityQuestions from "../registration/security-questions";
import { Description } from "../styles";
import FormAlert from "../form-alert";
import { safeRedirect } from "../../../utils/location";
import SharedLinks from "../shared-links";

class UpdatePassword extends React.Component {
  state = {};

  continue = () => {
    const { queryAfter, go } = this.props;
    queryAfter ? safeRedirect(queryAfter) : go("");
  };

  error = error => {
    let errorMessage = t(
      "messages.500-error",
      "Something went wrong. Please try again later."
    );
    if (error.errors && error.errors.password) {
      if (error.errors.password[0].match(/same|previous/i)) {
        errorMessage = t(
          "update-password.cannot-be-the-same",
          "New password cannot be the same as old password."
        );
      } else if (error.errors.password[0].match(/must contain/i)) {
        errorMessage = t(
          "registration.valid-password",
          "Password format error"
        );
      }
    } else if (error.errors && error.errors.current_password) {
      errorMessage = t(
        "update-password.current-incorrect",
        "Current password incorrect."
      );
    }
    this.setState({ error: errorMessage });
  };

  submit = e => {
    e.preventDefault();
    const form = e.target;
    const { jigsawBrand, setInfo } = this.props;
    const userObject = {
      last_brand_accessed: jigsawBrand,
      password: form.elements["user[password]"].value,
      current_password: form.elements["user[current-password]"].value,
      password_confirmation: form.elements["user[confirm-password]"].value,
      question_id: form.elements["user[question_id]"].value,
      question_response: form.elements["user[question_response]"].value
    };
    setInfo(userObject).then(({ success }) =>
      success ? this.continue() : this.error()
    );
  };

  renderTitle() {
    return (
      <Translation id="update-password.please-update">
        Please Update Your Information
      </Translation>
    );
  }

  renderCurrentPassword() {
    const { requireCurrentPassword } = this.props;
    if (requireCurrentPassword) {
      return (
        <TextField
          required
          id="current-password-field"
          type="password"
          name="user[current-password]"
          label={t("update-password.current-password", "Current Password")}
          fullWidth
        />
      );
    }
    return null;
  }

  renderUpdatePassword() {
    const { error } = this.state;
    return (
      <Form onSubmit={this.submit} id="update-password-form" method="post">
        {error && (
          <FormAlert level="error" key={`error-${error}`}>
            {error}
          </FormAlert>
        )}
        {this.renderCurrentPassword()}
        <Password />
        <SecurityQuestions />
        <Button id="submit-btn" fullWidth size="large">
          <Translation id="base.submit">Submit</Translation>
        </Button>
      </Form>
    );
  }

  render() {
    const { isUserFetching } = this.props;
    return (
      <ContainerLayout
        graphic="register"
        pageTitle={t("update-password.update-password", "Update Password")}
        title={this.renderTitle()}
      >
        <Description>
          <Translation id="update-password.update-messaging">
            For enhanced security, we’re asking all users to change the
            following information. New passwords must contain at least 8
            characters, an uppercase letter, a lowercase letter, and a special
            character.
          </Translation>
        </Description>

        {this.renderUpdatePassword()}
        <SharedLinks forgotPassword />
        {isUserFetching && <Spinner />}
      </ContainerLayout>
    );
  }
}

const mapStateToProps = state => ({
  isUserFetching: userSelectors.isUserFetching(state),
  queryAfter: routerSelectors.getQueryParam(state, "after"),
  requireCurrentPassword: brandSelectors.getBrandValue(
    state,
    "Password.requireCurrentPassword",
    false
  ),
  jigsawBrand: brandSelectors.getBrandValue(state, "jigsawBrand", "vitalsource")
});

const mapDispatchToProps = dispatch => ({
  setInfo: userObject => dispatch(userActions.setInfo(userObject)),
  go: path => dispatch(routerActions.go(path))
});

const ConnectedUpdatePassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatePassword);

export default ConnectedUpdatePassword;
